module.exports = __webpack_public_path__ + "img/new_pet.a69ae396.svg";